import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomSourceSelectorModule, CalendarPickerModule, ButtonToggleSelectModule } from "ngx-zcs-components";
import { IonicModule } from '@ionic/angular';

import { MonthlyYearlyEnergyOverviewComponent } from './monthly-yearly-energy-overview.component';
import { ComponentsModule } from '../components/components.module';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    MonthlyYearlyEnergyOverviewComponent,
  ],
  exports: [
    MonthlyYearlyEnergyOverviewComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CalendarPickerModule,
    CommonModule,
    ComponentsModule,
    CustomSourceSelectorModule,
    IonicModule,
    MatButtonModule,
    MatIconModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts/core') })
  ],
})

export class MonthlyYearlyEnergyOverviewModule { }
